<template>
  <div class="metric-form">
    <MetricSelect
      :value="selectedMetric"
      label="Status Metric*"
      required
      hint="If the metric isn't explicitly true, it displays as false"
      :items="metricOptions"
      data-testid="metric-field-informMetricId"
      @input="setMetric"
    />
    <MetricSelect
      :value="value.statusMetLabelAttribute"
      label="Status Met Label*"
      required
      hint="This displays with a green checkmark when participant meets requirement"
      :items="metricOptions"
      data-testid="metric-field-statusMetLabelAttribute"
      @input="setField('statusMetLabelAttribute', $event)"
    />
    <MetricSelect
      :value="value.statusNotMetLabelAttribute"
      label="Status Not Met Label*"
      required
      hint="This displays with a red x when participant has not met requirement"
      :items="metricOptions"
      data-testid="metric-field-statusNotMetLabelAttribute"
      @input="setField('statusNotMetLabelAttribute', $event)"
    />
  </div>
</template>

<script>
import MetricSelect from "./MetricSelect.vue";
import { hasMetricBinding, toMetricBinding, toMetricSelectValue } from "./metricOptions";

export default {
  name: "StatusForm",
  components: { MetricSelect },
  props: {
    value: { type: Object, required: true },
    metricOptions: { type: Array, default: () => [] },
    informProgramId: { type: String, default: null },
  },
  emits: ["input", "update:valid"],
  computed: {
    selectedMetric() {
      return toMetricSelectValue(this.value, this.metricOptions);
    },
    isValid() {
      return (
        hasMetricBinding(this.value) &&
        !!this.value.statusMetLabelAttribute &&
        !!this.value.statusNotMetLabelAttribute
      );
    },
  },
  watch: {
    isValid: {
      immediate: true,
      handler(valid) {
        this.$emit("update:valid", valid);
      },
    },
  },
  methods: {
    setMetric(selectValue) {
      this.$emit("input", {
        ...this.value,
        ...toMetricBinding(selectValue, this.metricOptions, this.informProgramId),
      });
    },
    setField(key, fieldValue) {
      this.$emit("input", { ...this.value, [key]: fieldValue });
    },
  },
};
</script>

<style scoped>
.metric-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
